import * as React from "react";

import "@mantine/notifications/styles.css";
import "./index.css";
import theme from "./Theme";

import "react-tooltip/dist/react-tooltip.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { MantineProvider, createTheme } from "@mantine/core";

import { Amplify, Auth } from "aws-amplify";

import { Provider as ReduxProvider } from "react-redux";

import store from "./redux/store";
import { Notifications } from "@mantine/notifications";
import ErrorBoundary from "./components/ErrorBoundery";

// eslint-disable-next-line import/no-unresolved
import "@aws-amplify/ui-react/styles.css";

import App from "./App";

import "./index.css";

const DO = () => {
  return (
    <ReduxProvider store={store}>
      <MantineProvider theme={theme}>
        <Notifications />
      
          <App />
     
      </MantineProvider>
    </ReduxProvider>
  );
};

export default DO;
